/**
 * The upload progress drawn around the order button of the TopBar : a ring filling with the
 * bytes sent, and "Envoi 65 %" under the button's label. Shown by the TopBar only while photos
 * are uploading.
 *
 * The ring is a rounded rect rather than a circle : 80px wide it is the circle around the
 * button, and it widens with the price pill when the button is hovered (TopBar "hover" class),
 * so one element follows both shapes. pathLength="100" makes the dash a plain percentage
 * whatever the width. The rect is sized from its box by a ResizeObserver, frame by frame while
 * the box's width transitions : a CSS width on a rect is not supported everywhere (Safari).
 */
fx.ns("desktop.common.actionbar", class OrderUploadProgress extends fx.Component {

	constructor()
	{
		super();

		this._percentage = 0;
	}

	get percentage()
	{
		return this._percentage;
	}

	set percentage(val)
	{
		this._percentage = Math.max(0, Math.min(100, Math.round(val)));
		this._update();
	}

	onReady()
	{
		super.onReady();

		if (window.ResizeObserver)
		{
			this._resizeObserver = new ResizeObserver(this._fitRing.bind(this));
			this._resizeObserver.observe(this.find(".ringBox"));
		}

		this._update();
	}

	destroy()
	{
		if (this._resizeObserver)
			this._resizeObserver.disconnect();

		super.destroy();
	}

	render()
	{
		// the circle around the button at rest ; _fitRing() widens it with its box
		let rect = '<rect x="1.5" y="1.5" rx="38.5" ry="38.5" width="77" height="77"';

		return '<div class="ringBox"><svg class="ring" width="100%" height="80">'
			+ rect + ' class="track"></rect>'
			+ rect + ' class="progress" pathLength="100"></rect>'
			+ '</svg></div>'
			+ '<div class="caption"></div>';
	}

	_fitRing()
	{
		let width = this.find(".ringBox").offsetWidth - 3;
		let rects = this.node.querySelectorAll("rect");

		// 0 while the ring is hidden (display none) : keep the circle
		if (width > 0)
			for (let i = 0; i < rects.length; i++)
				rects[i].setAttribute("width", width);
	}

	_update()
	{
		if (!this.node)
			return;

		this.find(".progress").setAttribute("stroke-dasharray", this._percentage + " 100");
		this.find(".caption").innerHTML = fx.text("Envoi $ %", this._percentage);
	}

});
